module.exports = __webpack_public_path__ + "static/img/063_TO8_1622_og.ca3b6e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/063_TO8_1622_og.jpg
// module id = DsXF
// module chunks = 0